import React, { useEffect, useState } from 'react';
import { Form, InputGroup, Spinner, Modal, Card } from 'react-bootstrap';
import { Button, ButtonGroup, Row, Col, CardBody } from 'reactstrap';
import Axios from 'axios';
import { useHistory } from 'react-router-dom';
import { Backspace, Save2Fill, Star } from 'react-bootstrap-icons';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import * as Yup from 'yup';
import { Field, Formik } from 'formik';

import dateformat from 'dateformat';

import common from '../../../commonData';
import { ProductList, Summary } from './cardaddSort';

function FactureMultiple({ setShowFact, show, setIsSave, setMsg, setMsgravity, selectedRows, actualise, setActualise }) {
    var ladate = new Date();
    const [codeart, setCodeart] = useState([]);
    const [client, setDataClient] = useState([]);
    const [load, setLoad] = useState(false);
    const history = useHistory();
    const [listeSelect, setListeSelect] = useState([]);

    const [states, setState] = useState({
        nobon: '',
        datesort: dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
        sitva: '0',
        typeFact: 'Facture',
        client_id: '',
        type_remise: '0',
        remise_main: 0
    });
    const { nobon, datesort, sitva, typeFact, client_id, type_remise, remise_main } = states;
    useEffect(() => {
        if (!localStorage.getItem('user-info')) {
            history.push('/login');
        }
        (async function anyNameFunction() {
            setLoad(true);
            const getCli = Axios.get(common.ipapi + '/api/client/indexmin');
            const getLigne = Axios.get(common.ipapi + '/api/sortieligne/get/' + selectedRows);
            await Axios.all([getLigne, getCli])
                .then(
                    Axios.spread((...response) => {
                        var t = [];
                        var tab = [];
                        setDataClient(response[1].data || []);

                        response[0].data.datas.forEach((element) => {
                            if (element.facture != null) {
                                setIsSave(true);
                                setMsgravity('danger');
                                setMsg('Veuillez saisir des BLs non facturés');
                                setShowFact(false);
                                return false;
                            }

                            if (response[0].data.datas[0].clients_id !== element.clients_id) {
                                setIsSave(true);
                                setMsgravity('warning');
                                setMsg('Les BLs sélectionnés doivent appartenir au même client');
                                setShowFact(false);
                                return false;
                            }
                            if (response[0].data.datas[0].type_remise !== element.type_remise) {
                                setIsSave(true);
                                setMsgravity('warning');
                                setMsg("Impossible de facturer car le type de remise est différent d'une sortie à une autre");
                                setShowFact(false);
                                return false;
                            }
                            if (response[0].data.datas[0].remise_main !== element.remise_main) {
                                setIsSave(true);
                                setMsgravity('warning');
                                setMsg("Impossible de facturer car le valeur de la remise est différente d'une sortie à une autre");
                                setShowFact(false);
                                return false;
                            }
                            if (response[0].data.datas[0].sitva != element.sitva) {
                                setIsSave(true);
                                setMsgravity('warning');
                                setMsg("Impossible de facturer car la tva est différente d'une sortie à une autre");
                                setShowFact(false);
                                return false;
                            }
                            tab.push(element.numbon);
                            var rem = response[0].data.datas[0].lignesort[0].pivot.remise;
                            element.lignesort.forEach((elt) => {
                                if (rem !== elt.pivot.remise) {
                                    setIsSave(true);
                                    setMsgravity('warning');
                                    setMsg("Impossible de facturer car la valeur des remise ligne est différente d'une sortie à une autre");
                                    setShowFact(false);
                                    return false;
                                }
                                if (elt.pivot.quantite - elt.pivot.quantiteretour > 0) {
                                    t.push({
                                        id: elt.id,
                                        numbon: element.numbon,
                                        prix: elt.pivot.prix,
                                        nobon: element.numbon,
                                        qrbarre: elt.qrbarre,
                                        descriptionart: elt.descriptionart,
                                        quantite: elt.pivot.quantite - elt.pivot.quantiteretour,
                                        remise: elt.pivot.remise,
                                        prixachat: elt.pivot.prix_achat
                                    });
                                }
                            });
                        });
                        setState({
                            remise_main: response[0].data.datas[0].remise_main,
                            type_remise: response[0].data.datas[0].type_remise,
                            sitva: response[0].data.datas[0].sitva,
                            client_id: response[0].data.datas[0].clients_id
                        });
                        tab.concat(codeart);
                        setCodeart(selectedRows);
                        t.sort(GetSortOrder('id'));
                        setListeSelect(t);
                        setLoad(false);
                    })
                )
                .catch((errors) => {
                    setLoad(false);
                });
        })();
    }, [history, codeart, setShowFact]);

    function GetSortOrder(prop) {
        return function (a, b) {
            if (a[prop] < b[prop]) {
                return 1;
            } else if (a[prop] > b[prop]) {
                return -1;
            }
            return 0;
        };
    }
    function groupBy(tableauObjets) {
        var result = [];
        var ind = 0;
        var prixvente = 0;
        var prixachat = 0;
        var remise = 0;
        return tableauObjets.reduce(function (res, value, index) {
            ind++;
            prixvente += value.prix;
            prixachat += value.prixachat;
            remise += value.remise;
            if (!res[value.id]) {
                res[value.id] = {
                    id: value.id,
                    quantite: 0,
                    prix: 0,
                    descriptionart: value.descriptionart,
                    remise: 0,
                    prixachat: 0,
                    prixventes: 0
                };
                result.push(res[value.id]);
                ind = 1;
                prixvente = value.prix;
                prixachat = value.prixachat;
                remise = value.remise;
            }
            res[value.id].prixventes += value.quantite * value.prix;
            res[value.id].quantite += value.quantite;
            res[value.id].prix = res[value.id].prixventes / res[value.id].quantite; ///prixvente / ind;
            res[value.id].prixachat = prixachat / ind;
            res[value.id].remise = remise / ind;
            return res;
        }, {});
    }

    const onChangeProductQuantity = (index, event) => {
        const cloneProducts = [...listeSelect];
        cloneProducts[index].quantite = event.target.value;
        setListeSelect(cloneProducts);
    };

    const onChangePrestation = (index, event) => {
        const value = event.target.value;
        const cloneProducts = [...listeSelect];
        cloneProducts[index].descriptionart = value;
        setListeSelect(cloneProducts);
    };

    const onChangeRemise = (index, event) => {
        const value = event.target.value;
        const cloneProducts = [...listeSelect];
        cloneProducts[index].remise = value;

        setListeSelect(cloneProducts);
    };

    const onChangePrix = (index, event) => {
        const value = event.target.value;
        const valueInt = parseInt(value);
        const cloneProducts = [...listeSelect];
        cloneProducts[index].prix = valueInt;

        setListeSelect(cloneProducts);
    };

    const onRemoveProduct = (i, id) => {
        var filteredProduct = [];
        setLoad(true);
        filteredProduct = listeSelect.filter((product, index) => {
            return index !== i;
        });
        setListeSelect(filteredProduct);
        setMsg('Ligne supprimée');
        setMsgravity('info');
        setIsSave(true);
        setLoad(false);
    };

    const handleClose = () => {
        setShowFact(false);
        setIsSave(false);
    };

    return (
        <>
            <Modal show={load} size="sm" aria-labelledby="contained-modal-title-vcenter" centered>
                <Modal.Body>
                    Veuillez patienter.......
                    <Spinner animation="border" variant="success" />
                </Modal.Body>
            </Modal>

            <Formik
                initialValues={{
                    numbon: nobon,
                    date: datesort || dateformat(ladate.getMonth() + 1 + '/' + ladate.getDate() + '/' + ladate.getFullYear(), 'yyyy-mm-dd'),
                    client_id: client_id,
                    user_id: common.userid,
                    sitva: sitva || '0',
                    type: typeFact || 'Proforma',
                    blsids: JSON.stringify(selectedRows),
                    codeart: JSON.stringify(groupBy(listeSelect)),
                    societe: common.societe,
                    type_remise: type_remise || '0',
                    remise_main: remise_main || '0',
                    submit: null
                }}
                enableReinitialize
                validationSchema={Yup.object().shape({
                    client_id: Yup.number().required(common.msg),
                    date: Yup.date().required(common.msg)
                })}
                onSubmit={async (values, { setSubmitting }) => {
                    try {
                        setLoad(true);
                        let url = common.ipapi + '/api/facture/create';
                        await Axios.post(url, values)
                            .then((res) => {
                                if (res.data.status === 1) {
                                    setMsg(res.data.msg);
                                    setMsgravity('success');
                                    setIsSave(true);
                                    setLoad(false);
                                    setShowFact(false);
                                    setActualise(!actualise);
                                } else if (res.data.status === 2) {
                                    setMsg(res.data.msg);
                                    setMsgravity('danger');
                                    setIsSave(true);
                                    setLoad(false);
                                } else {
                                    if (res.data.code === 23000) {
                                        setMsg('Ce numéro de bon existe déja');
                                        setMsgravity('danger');
                                        setIsSave(true);
                                        setLoad(false);
                                    } else {
                                        setMsg(res.data.msg);
                                        setMsgravity('danger');
                                        setIsSave(true);
                                        setLoad(false);
                                    }
                                }
                            })
                            .catch((error) => {
                                setIsSave(true);
                                setMsgravity('danger');
                                setLoad(false);
                            });
                        setSubmitting(false);
                    } catch (err) {
                        setMsg('Une erreur à eu lieu');
                        setMsgravity('danger');
                        setIsSave(true);
                        setLoad(false);
                    }
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values, setFieldValue, setFieldTouched }) => (
                    <Modal show={show} fullscreen={true} onHide={handleClose}>
                        <div className="content">
                            <Form noValidate onSubmit={handleSubmit}>
                                <Modal.Header>
                                    FACTURATION D'ARTICLES LIVREES
                                    <Backspace onClick={handleClose} color="red" size={30} />
                                </Modal.Header>
                                <Modal.Body>
                                    <div id="lightbody">
                                        <Card>
                                            <CardBody>
                                                <Row>
                                                    <Col md={4}>
                                                        <Form.Group as={Row} className="mb-3" controlId="formHorizontalEmail">
                                                            <Form.Label column sm={3}>
                                                                Type:
                                                            </Form.Label>
                                                            <Col sm={9}>
                                                                <div role="group" aria-labelledby="my-radio-group">
                                                                    <label className="radio">
                                                                        <Field type="radio" disabled={true} name="type" value="Proforma" />
                                                                        Proforma
                                                                    </label>
                                                                    <label className="radio">
                                                                        <Field type="radio" disabled={true} name="type" value="Facture" />
                                                                        Facture
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                Nom client:
                                                            </Form.Label>
                                                            <Col sm={9}>
                                                                <InputGroup>
                                                                    <Typeahead
                                                                        id="client_id"
                                                                        multiple={false}
                                                                        // onChange={(selected) => {
                                                                        //     const value = selected.length > 0 ? selected[0].id : 0;
                                                                        //     setFieldValue('client_id', value);
                                                                        // }}
                                                                        // onInputChange={(text, event) => setFieldValue('client_id', text)}
                                                                        // onBlur={(e) => setFieldTouched('client_id', true)}
                                                                        labelKey="raisonsocial"
                                                                        options={client}
                                                                        selected={client.slice(
                                                                            client.findIndex((element) => element.id === values.client_id),
                                                                            client.findIndex((element) => element.id === values.client_id) +
                                                                                1
                                                                        )}
                                                                        disabled={true}
                                                                    />
                                                                </InputGroup>
                                                                {errors.client_id && <div id="feedback">{errors.client_id}</div>}
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                N° pièce:
                                                            </Form.Label>
                                                            <Col sm={4}>
                                                                <Form.Control
                                                                    id="numbon"
                                                                    type="text"
                                                                    placeholder="N° de facture ou devis"
                                                                    aria-describedby="inputGroupPrepend"
                                                                    size="sm"
                                                                    value={values.numbon}
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    // onChange={(e) => setNobon(e.target.value)}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                Date facture: <Star color="red" size={10} />
                                                            </Form.Label>
                                                            <Col sm={4}>
                                                                <Form.Control
                                                                    id="date"
                                                                    type="date"
                                                                    placeholder="Date facture"
                                                                    aria-describedby="inputGroupPrepend"
                                                                    onBlur={handleBlur}
                                                                    onChange={handleChange}
                                                                    size="sm"
                                                                    value={values.date}
                                                                    // onChange={(e) => setDatesort(e.target.value)}
                                                                />
                                                            </Col>
                                                            {errors.date && <div id="feedback">{errors.date}</div>}
                                                        </Form.Group>
                                                        <div role="group" aria-labelledby="my-radio-group">
                                                            <label className="radio">
                                                                <Field type="radio" disabled={true} name="sitva" value="0" />
                                                                TVA applicable
                                                            </label>
                                                            <label className="radio">
                                                                <Field type="radio" disabled={true} name="sitva" value="1" />
                                                                TVA non applicable
                                                            </label>
                                                        </div>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                Type remise:
                                                            </Form.Label>
                                                            <Col sm={9}>
                                                                <div role="group" aria-labelledby="my-radio-group">
                                                                    <label className="radio">
                                                                        <Field type="radio" disabled={true} name="type_remise" value="0" />
                                                                        Pourcentage
                                                                    </label>
                                                                    <label className="radio">
                                                                        <Field type="radio" disabled={true} name="type_remise" value="1" />
                                                                        Montant fixe
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                        </Form.Group>
                                                        <Form.Group as={Row} className="mb-3">
                                                            <Form.Label column sm={3}>
                                                                Valeur remise:
                                                            </Form.Label>
                                                            <Col sm={9}>
                                                                <Form.Control
                                                                    id="remise_main"
                                                                    type="number"
                                                                    aria-describedby="inputGroupPrepend"
                                                                    size="sm"
                                                                    value={values.remise_main}
                                                                    disabled={true}
                                                                />
                                                            </Col>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col md={8}>
                                                        <div>
                                                            <ProductList
                                                                products={listeSelect}
                                                                onChangeProductQuantity={onChangeProductQuantity}
                                                                onRemoveProduct={onRemoveProduct}
                                                                onChangePrestation={onChangePrestation}
                                                                onChangeRemise={onChangeRemise}
                                                                onChangePrix={onChangePrix}
                                                                sisortie={false}
                                                            />
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </CardBody>
                                        </Card>
                                    </div>
                                </Modal.Body>
                                <Modal.Footer>
                                    <Summary
                                        listeSelect={listeSelect}
                                        sitva={values.sitva}
                                        type_remise={values.type_remise}
                                        remise_main={values.remise_main}
                                    />
                                    <div className="ml-auto">
                                        <ButtonGroup size="sm">
                                            <Button color="secondary" onClick={handleClose}>
                                                <Backspace color="red" size={20} />
                                            </Button>
                                            <Button type="submit" color="warning">
                                                <Save2Fill color="#807f7e" size={20} /> Enregister
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </Modal.Footer>
                            </Form>
                        </div>
                    </Modal>
                )}
            </Formik>
        </>
    );
}

export default FactureMultiple;
